<template>  
  <modal :value="value"
          max-width="750"
          content-class="email-modal modal-device"
          :has-padding="false"
          @input="emitInput">              

    <div class="email-modal-body">
      <h1>{{$t('message.marketingGenerics.message.sendTest')}}</h1>

      <v-text-field v-model="emailVal"
                    class="email-modal-body-inpt"
                    height="30"
                    :label="$t('message.generics.message.email')"></v-text-field>

      <v-card-actions class="sms-add-plan-modal-actions">
        <button class="btn btn-extra-round  btn-outline sms-add-plan-modal-actions-skip"
                @click="hideModal">
            {{$t('message.generics.message.cancel')}}
        </button>
        <button class="btn btn-extra-round btn-primary"
                @click="sendTest">
            {{$t('message.marketingGenerics.message.sendTest')}}
        </button>
      </v-card-actions>
    </div>
  </modal>  
</template>

<script>
import Modal from "@/components/generic/Modal";

export default {
  components: {Modal},
  data() {
    return {
      emailVal: undefined,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
    },
  },

  computed: {},

  watch: {},

  methods: {
    hideModal() {
      this.emitInput(false);
    },
    emitInput(value) {
      this.$emit("input", value);
    },
    async sendTest() {
      await this.$api.marketing.email.send.test({
        emailId: this.item.id,
        emails: this.emailVal,
      });

      this.hideModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.email-modal {
  .email-modal-body {
    padding: 25px 100px;

    h1 {
      text-align: center;
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 40px;
    }

    .email-modal-body-inpt {
      margin-bottom: 20px !important;
    }

    .sms-add-plan-modal-actions {
      display: flex;
      justify-content: space-between;

      .btn {
        min-width: 200px;
      }

      .sms-add-plan-modal-actions-skip {
        border: 1px solid gray;
      }
    }
  }
}
</style>
